import VueOffline from 'vue-offline'

export const ProductGallery = {
  name: 'ProductGallery',
  components: {
    VueOffline
  },
  props: {
    gallery: {
      type: Array,
      required: true
    },
    large: {
      type: Array,
      required: true
    },
    stylistNotes: {
      type: String,
      required: false
    },
    stylistHeader: {
      type: String,
      required: false
    },
    vimeoId: {
      type: String,
      required: false
    },
    configuration: {
      type: Object,
      required: true
    },
    offline: {
      type: Object,
      required: false
    },
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
  }
}
